import { cn } from '@commenda/utils';
import moment from 'moment';
import { CALENDAR_BG_WEEKEND, CALENDAR_DIVIDER } from './calendar.constants';
import CalendarDateHeader from './CalendarDateHeader';
import CalendarEventPill from './CalendarEventPill';
import { DAY_HEADERS } from './calendarGrid';
import { RbcEvent } from './calendar.types';

interface CalendarWeekGridProps {
  dates: Date[];
  eventsByDate: Map<string, RbcEvent[]>;
  onSelectEvent: (event: RbcEvent) => void;
}

const CalendarWeekGrid = ({
  dates,
  eventsByDate,
  onSelectEvent,
}: CalendarWeekGridProps) => {
  const todayKey = moment().format('YYYY-MM-DD');

  const todayDayIndex = new Date().getDay();

  return (
    <div className="flex flex-col flex-1 min-h-0">
      <div className="grid grid-cols-7 shrink-0">
        {dates.map((date, index) => {
          const isLastCol = index === 6;
          const isWeekend = index === 0 || index === 6;
          const dateFormatted = moment(date).format('YYYY-MM-DD')

          return (
            <div
              key={index}
              style={{
                borderRight: isLastCol ? 'none' : `1px solid ${CALENDAR_DIVIDER}`,
                backgroundColor: isWeekend ? CALENDAR_BG_WEEKEND : undefined,
              }}
            >
              <div
                className={cn(
                  'flex items-center justify-center pb-2 txt-small-bold',
                  dateFormatted === todayKey ? 'text-fg-primary' : 'text-fg-quaternary'
                )}
              >
                {DAY_HEADERS[index]}
              </div>
              <CalendarDateHeader date={date} label={String(date.getDate())} />
            </div>
          );
        })}
      </div>

      <div className="grid grid-cols-7 flex-1 min-h-0 border border-border-primary rounded overflow-hidden">
        {dates.map((date, index) => {
          const key = moment(date).format('YYYY-MM-DD');
          const dayEvents = eventsByDate.get(key) ?? [];
          const isWeekend = index === 0 || index === 6;
          const isLastCol = index === 6;
          const isPast = moment(date).isBefore(moment(), 'day');
          const eventsOpacity = isPast ? (isWeekend ? 0.5 : 0.25) : 1;

          return (
            <div
              key={key}
              className="flex flex-col p-1 gap-0.5"
              style={{
                borderRight: isLastCol ? 'none' : `1px solid ${CALENDAR_DIVIDER}`,
                backgroundColor: isWeekend ? CALENDAR_BG_WEEKEND : undefined,
              }}
            >
              {dayEvents.map((event) => (
                <div
                  key={event.id}
                  onClick={() => onSelectEvent(event)}
                  className="cursor-pointer"
                  style={{ opacity: eventsOpacity }}
                >
                  <CalendarEventPill event={event} />
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CalendarWeekGrid;
